import ServiceDetailPage from '../components/services/ServiceDetailPage';
import { serviceDetails } from '../data/serviceDetails';

function Hydraulics() {
  return <ServiceDetailPage service={serviceDetails.hydraulics} />;
}

export default Hydraulics;
